import { create } from 'zustand'
import type { StateCreator } from 'zustand'
import { persist } from 'zustand/middleware'
import type { PersistOptions } from 'zustand/middleware'

interface UiState {
  developerMode: boolean
  setDeveloperMode: (devMode: boolean) => void
}

type Persist = (
  config: StateCreator<UiState>,
  options: PersistOptions<UiState>,
) => StateCreator<UiState>

export const useUiStore = create<UiState>(
  (persist as Persist)(
    (set) => ({
      developerMode: false,
      setDeveloperMode: (developerMode) => set(() => ({ developerMode })),
    }),
    {
      name: 'ui',
    },
  ),
)
